import { themedStyleSheet } from '../../../../themes/themedStyleSheet';

export const stylesCropCircle = themedStyleSheet((role) => ({
  container: {
    flex: 1,
    flexDirection: 'column',
    padding: 20,
    marginBottom: 20,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
  },
  scrollviewContainer: {
    flex: 1,
    marginBottom: 20,
  },
  questionContainer: {
    backgroundColor: role.surface,
    padding: 6,
    marginBottom: 12,
  },
  instructionsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: 24,
    marginBottom: 18,
  },
  questionTitleContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: 20,
    marginBottom: 4,
  },
}));
